import React from 'react'

const PhoneSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 17.057 17.062'
    >
      <g id='Page-1' transform='translate(59.518 -10.484)'>
        <g id='Dribbble-Light-Preview' transform='translate(-59.518 10.484)'>
          <g id='icons'>
            <path
              id='call-_192_'
              data-name='call-[#192]'
              d='M63.75,7175.784c-.526,1.591-2.589,2.387-4.063,2.263a12.905,12.905,0,0,1-5.865-2.435,19.338,19.338,0,0,1-6.067-7.231,6.078,6.078,0,0,1,.248-6.3,2.43,2.43,0,0,1,1.922-1.08c1.169-.058,1.333.614,1.734,1.659.3.773.7,1.57.921,2.377.417,1.511-1.042,1.569-1.226,2.8-.115.785.827,1.82,1.252,2.376a11.426,11.426,0,0,0,2.966,2.729c.647.409,1.692,1.148,2.433.739,1.142-.624,1.034-2.547,2.63-1.9.827.341,1.627.83,2.416,1.251,1.22.659,1.163,1.331.7,2.752-.348,1.045.348-1.057,0,0'
              transform='translate(-47 -7160.998)'
              fill='#fff'
              fillRule='evenodd'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PhoneSvg
